import React from "react";
import {
  CommonFormItemWithLabel,
  CommonModal,
} from "../../../../../components/common/MoleculesCommonComponent";
import {
  CommonButton,
  CommonSelect,
  CommonTextCustomSize
} from "../../../../../components/common/AtomCommonComponents";
import { Col, Empty, Form, Row } from "antd";
interface SelectMarketModalTypes {
  isSelectMarketModalVisible: boolean;
  onCloseModal: () => void;
  onSubmitSelectedMarket: (branch: any) => void;
  branchesData: any;
}

const SelectMarketModal = (props: SelectMarketModalTypes) => {
  const [form] = Form.useForm();
  const {
    isSelectMarketModalVisible,
    onCloseModal,
    onSubmitSelectedMarket,
    branchesData,
  } = props;

  const onCancelModal = () => {
    form.resetFields();
    onCloseModal();
  };

  const onSubmit = async () => {
    const values = await form.validateFields();

    if (values.branches !== undefined) {
      const selectedBranch = branchesData.filter(
        (item: any) => item.value === values.branches
      );
      onSubmitSelectedMarket(selectedBranch[0]);
    }
    onCloseModal();
  };

  const onSelectMarket = (value: string) => {
    return value !== undefined;
  };

  return (
    <CommonModal
      margintop="20px"
      maskClosable={false}
      visible={isSelectMarketModalVisible}
      onCancel={onCancelModal}
      footer={null}
    >
      <Form form={form} validateTrigger="onChange">
        <CommonTextCustomSize fontSize="20px" fontWeight="600">
          Search Location
        </CommonTextCustomSize>
        <CommonTextCustomSize fontSize="14px">
          Please enter your location in order for us to suggest the best promo
          deal, regional content, offerings, and pricing in your location
        </CommonTextCustomSize>
        <Row gutter={[16, 16]}>
          <Col span={19}>
            <div id="select">
              <CommonFormItemWithLabel name={"branches"}>
                <CommonSelect
                  getPopupContainer={() =>
                    document.getElementById("select") as any
                  }
                  notFoundContent={
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description={
                        "No data is found for a specific data search."
                      }
                    />
                  }
                  showArrow
                  showSearch={false}
                  onSelect={(value: any) => onSelectMarket(value) as any}
                  defaultValue={"Home Delivery"}
                  color="primary"
                  options={branchesData}
                />
              </CommonFormItemWithLabel>
            </div>
          </Col>
          <Col span={5}>
            <CommonButton
              background={"primary"}
              color="white"
              borderradius="100px"
              width="80px"
              onClick={onSubmit}
            >
              Go
            </CommonButton>
          </Col>
        </Row>
      </Form>
    </CommonModal>
  );
};

export default SelectMarketModal;
